import clouds1 from "../../images/assets/sky/SKY1_CLOUDS1.svg"
import clouds2 from "../../images/assets/sky/SKY1_CLOUDS2.svg"
import clouds3 from "../../images/assets/sky/SKY1_CLOUDS3.svg"
import ground from "../../images/assets/sky/SKY1_FLOOR1.svg"
import EarthSectionBase from "./EarthSectionBase";
import {useTranslation} from "react-i18next";
import Tools from "../../pages/Tools";
import {useMemo, useState, useEffect, useRef} from "react";
import CollectibleCoin, {getRandomCoinHover} from "../shared/CollectibleCoin";
import coin from "../../images/assets/shared/R_COIN.svg";
import { FaInfoCircle } from "react-icons/fa";

export default function Sky1 ({
                                  layer,
                                  collectedCoinIds = [],
                                  onCoinCollect
                              }){
    const { t } = useTranslation();

    const coinStyles = useMemo(
        () => [getRandomCoinHover()],
        []
    );

    const coins = [
        { id: "sky1-coin-1", className: "sky1-coin", style: coinStyles[0] },
    ]

    const useIsMobile = () => {
        const [isMobile, setIsMobile] = useState(false);
        useEffect(() => {
            const check = () => setIsMobile(window.matchMedia("(pointer: coarse)").matches);
            check();
            window.matchMedia("(pointer: coarse)").addEventListener("change", check);
            return () => window.matchMedia("(pointer: coarse)").removeEventListener("change", check);
        }, []);
        return isMobile;
    };

    const Tooltip = ({ content }) => {
        const [open, setOpen] = useState(false);
        const isMobile = useIsMobile();
        const triggerRef = useRef(null);
        const tooltipRef = useRef(null);
        const [pos, setPos] = useState({ top: 0, left: 0 });

        // Close on outside click (desktop)
        useEffect(() => {
            if (!open || isMobile) return;
            const handler = (e) => {
                if (!triggerRef.current?.contains(e.target) && !tooltipRef.current?.contains(e.target)) {
                    setOpen(false);
                }
            };
            document.addEventListener("mousedown", handler);
            return () => document.removeEventListener("mousedown", handler);
        }, [open, isMobile]);

        const handleTrigger = () => {
            if (!isMobile && triggerRef.current) {
                const rect = triggerRef.current.getBoundingClientRect();
                setPos({
                    top: rect.top + rect.height / 2,  // vertically centered
                    left: rect.right + 20,              // to the right + small gap
                });
            }
            setOpen((v) => !v);
        };

        return (
            <>
                {/* Trigger button */}
                <span
                    ref={triggerRef}
                    onClick={handleTrigger}
                    style={{ cursor: "pointer" }}
                >
                    <FaInfoCircle
                        aria-label="More info"
                        size={isMobile ? 17 : 25}
                        color={"#def8fb"}
                    />
                </span>


                {/* MOBILE: bottom sheet */}
                {isMobile && open && (
                    <>
                        <div
                            onClick={() => setOpen(false)}
                            style={{
                                position: "fixed", inset: 0,
                                background: "rgba(0,0,0,0.6)", zIndex: 10,
                            }}
                        />
                        <div
                            style={{
                                position: "fixed", bottom: 0, left: 0, right: 0,
                                background: "var(--color-background-primary)",
                                borderRadius: "16px 16px 0 0",
                                padding: "24px 20px 36px",
                                zIndex: 1001,
                                border: "0.5px solid var(--color-border-tertiary)",
                            }}
                        >
                            <div style={{
                                width: 36, height: 4, borderRadius: 2,
                                background: "var(--color-border-secondary)",
                                margin: "0 auto 20px",
                            }} />
                            <p className={"tools-info-mobile"}>{content}</p>
                        </div>
                    </>
                )}

                {/* DESKTOP: floating tooltip */}
                {!isMobile && open && (
                    <div
                        ref={tooltipRef}
                        style={{
                            top: pos.top,
                            left: pos.left,
                        }}
                        className={"tools-info-desktop"}
                    >
                        {content}
                    </div>
                )}
            </>
        );
    };


    return (
        <EarthSectionBase
            id={layer.id}
            background={layer.bg}
            className={""}
        >
            <img src={clouds1} alt="" className={'background-img sky1-clouds1'} />
            <img src={clouds2} alt="" className={'background-img sky1-clouds2'} />
            <img src={clouds3} alt="" className={'background-img sky1-clouds3'} />
            <img src={ground} alt="" className={'background-img sky1-ground'} />

            {coins.map((coinItem) => (
                <CollectibleCoin
                    key={coinItem.id}
                    id={coinItem.id}
                    src={coin}
                    className={`background-img coin ${coinItem.className} ${
                        collectedCoinIds.includes(coinItem.id) ? "coin-collected" : "coin-clickable"
                    }`}
                    style={coinItem.style}
                    isCollected={collectedCoinIds.includes(coinItem.id)}
                    onCollect={onCoinCollect}
                />
            ))}

            <div className={'tools-title-container section-title-position'}>
                <h1 className='section-title'>{t('toolsTitle')}</h1>
                <Tooltip content={t('toolsInfo')}/>
            </div>

            <Tools />
        </EarthSectionBase>
    )
}